export interface SupportedCity {
  label: string;
  value: string;
  center: { lat: number; lng: number };
  aliases: string[];
  adminOnly?: boolean;
}

export const SUPPORTED_CITIES: SupportedCity[] = [
  {
    label: 'Dresden',
    value: 'dresden',
    center: { lat: 51.0504, lng: 13.7373 },
    aliases: ['dresden'],
  },
  {
    label: 'Delhi NCR',
    value: 'delhi',
    center: { lat: 28.6139, lng: 77.209 },
    aliases: ['delhi', 'delhi ncr', 'new delhi', 'nct of delhi', 'gurugram', 'gurgaon', 'noida', 'ghaziabad', 'faridabad'],
    adminOnly: true,
  },
];

function normalizeCityKeyBase(value?: string | null): string {
  return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

export function normalizeCityKey(value?: string | null): string {
  const normalized = normalizeCityKeyBase(value);
  const city = SUPPORTED_CITIES.find(
    c => c.value === normalized || c.aliases.some(a => normalizeCityKeyBase(a) === normalized),
  );
  return city?.value || normalized;
}

export function findSupportedCity(key: string): SupportedCity | undefined {
  const normalized = normalizeCityKey(key);
  return SUPPORTED_CITIES.find(
    c => c.value === normalized || c.aliases.some(a => normalizeCityKeyBase(a) === normalized),
  );
}

export function canAccessCity(cityKey: string | null | undefined, role: unknown): boolean {
  const city = findSupportedCity(cityKey || '');
  if (!city) return false;
  return city.adminOnly !== true || role === 'admin';
}

export function getVisibleCities(role: unknown): SupportedCity[] {
  return SUPPORTED_CITIES.filter(city => city.adminOnly !== true || role === 'admin');
}

export function getDefaultVisibleCity(role: unknown): SupportedCity {
  return getVisibleCities(role)[0] || SUPPORTED_CITIES[0];
}

export function getCityCenter(cityKey: string): { lat: number; lng: number } {
  return findSupportedCity(cityKey)?.center ?? SUPPORTED_CITIES[0].center;
}

export function getCityZoom(cityKey: string): number {
  return cityKey === 'dresden' ? 12 : 11;
}
